import { Typography } from "@mui/material"
import React from "react"

const EmailBoxTypography = ({ variant, text, pt, pb }) => {
  return (
    <Typography pt={pt} pb={pb} variant={variant}>
      {text}
    </Typography>
  )
}

export default EmailBoxTypography
